import React, { ReactNode } from 'react';
import { Icon, IconTypeKey } from 'hfs-common-ui';
import ReactDOM from 'react-dom';
import getPortalElement from '~/utils/get-portal-element/get-portal-element';
import { useDisableBodyScroll } from '~/hooks/use-disable-body-scroll';
import UserProfileMenuHeader from '../UserProfileMenuHeader/UserProfileMenuHeader';
import * as S from './styled';

export interface Props {
  position?: 'left' | 'right';
  icon?: IconTypeKey;
  iconActive?: IconTypeKey;
  children: ReactNode;
  isOpen?: boolean;
  toggleOpen: () => void;
  isAvatarIcon?: boolean;
}

export interface PropsNavDrawer {
  position?: 'left' | 'right';
  children: ReactNode;
  isOpen?: boolean;
}

const NavigationDrawer = ({ position = 'left', isOpen = false, children }: PropsNavDrawer) => {
  return ReactDOM.createPortal(
    <S.NavigationDrawer $position={position} $visible={isOpen} data-testid="navigationDrawer">
      {children}
    </S.NavigationDrawer>,
    getPortalElement()
  );
};

const IconButton = ({
  isOpen,
  toggleOpen,
  icon,
  iconActive,
  isAvatarIcon,
}: {
  isOpen: boolean;
  toggleOpen: () => void;
  icon: IconTypeKey;
  iconActive: IconTypeKey;
  isAvatarIcon?: boolean;
}) => {
  const containerId = isAvatarIcon
    ? 'user-avatar'
    : `mobile-drawer-menu-${isOpen ? 'open' : 'closed'}`;
  let content;
  if (isAvatarIcon) {
    content = (
      <UserProfileMenuHeader
        onlyAvatar
        open={isOpen}
        testIdClosed="iconNavDrawerClosed"
        testidOpen="iconNavDrawerOpen"
      />
    );
  } else if (isOpen) {
    content = (
      <div data-testid="iconNavDrawerOpen">
        <Icon type={iconActive} />
      </div>
    );
  } else {
    content = (
      <div data-testid="iconNavDrawerClosed">
        <Icon type={icon} />
      </div>
    );
  }

  return (
    <S.TransparentButton id={containerId} onClick={toggleOpen}>
      {content}
    </S.TransparentButton>
  );
};

const MobileMenuDrawer = ({
  position = 'left',
  icon = 'action.hamburger',
  iconActive = 'action.close',
  isOpen = false,
  toggleOpen,
  children,
  isAvatarIcon = true,
}: Props) => {
  useDisableBodyScroll(isOpen);
  return (
    <>
      <IconButton
        isOpen={isOpen}
        toggleOpen={toggleOpen}
        icon={icon}
        iconActive={iconActive}
        isAvatarIcon={isAvatarIcon}
      />
      <NavigationDrawer position={position} isOpen={isOpen}>
        {children}
      </NavigationDrawer>
    </>
  );
};

export default MobileMenuDrawer;
